import { __values } from "tslib";
import { QueryExpType, UNLIMITED, equalsKeyPaths, QueryAggregateType, } from '@tencent/memoire-core';
import { QueryTreeNodeType } from './query-tree';
var QueryPlanner = /** @class */ (function () {
    function QueryPlanner(collectionSchema, comparer) {
        this.collectionSchema = collectionSchema;
        this.comparer = comparer;
    }
    QueryPlanner.prototype.plan = function (query, aggregate) {
        return {
            root: this.getRootNode(query, aggregate),
            aggregate: aggregate,
        };
    };
    QueryPlanner.prototype.getRootNode = function (query, aggregate) {
        if (query.exp.type === QueryExpType.NONE) {
            return this.getSkipNode();
        }
        var root = this.getBaseNode(query.exp);
        if (aggregate === QueryAggregateType.ENTRIES || aggregate === QueryAggregateType.VALUES || query.order) {
            root = this.getHydrateNode([root]);
        }
        if (query.order) {
            root = this.getSortNode(query.order.path, query.order.type, [root]);
        }
        if (query.offset || query.limit !== UNLIMITED) {
            root = this.getPaginateNode(query.offset, query.limit, [root]);
        }
        root = this.getDistinctNode([root]);
        return root;
    };
    QueryPlanner.prototype.getBaseNode = function (exp) {
        if (exp.type === QueryExpType.ALL) {
            return this.getScanAllNode();
        }
        if (exp.type === QueryExpType.NONE) {
            return this.getSkipNode();
        }
        if (exp.type === QueryExpType.FILTER) {
            return this.getFilterNode(exp);
        }
        return this.getLogicExpNode(exp);
    };
    QueryPlanner.prototype.getLogicExpNode = function (logicExp) {
        var e_1, _a;
        var nodes = [];
        try {
            for (var _b = __values(logicExp.exps), _c = _b.next(); !_c.done; _c = _b.next()) {
                var exp = _c.value;
                nodes.push(exp.type === QueryExpType.FILTER ? this.getFilterNode(exp) : this.getLogicExpNode(exp));
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return logicExp.type === QueryExpType.AND ? this.getIntersectNode(nodes) : this.getUnionNode(nodes);
    };
    QueryPlanner.prototype.getFilterNode = function (exp) {
        if (!exp.path || exp.hints.isKey) {
            return this.getScanNode(exp.hints.intervalGroup.intervals);
        }
        var index = exp.hints.indices.find(function (index) { return equalsKeyPaths(index.path, exp.path); });
        if (index) {
            return this.getIndexScanNode(exp.hints.intervalGroup.intervals, index);
        }
        return this.getMemFilterNode(exp.hints.intervalGroup.intervals, exp.path);
    };
    QueryPlanner.prototype.getIntersectNode = function (children) {
        return { type: QueryTreeNodeType.INTERSECT, comparer: this.comparer, children: children };
    };
    QueryPlanner.prototype.getDistinctNode = function (children) {
        if (children === void 0) { children = []; }
        return { type: QueryTreeNodeType.DISTINCT, comparer: this.comparer, children: children };
    };
    QueryPlanner.prototype.getUnionNode = function (children) {
        if (children === void 0) { children = []; }
        return { type: QueryTreeNodeType.UNION, children: children };
    };
    QueryPlanner.prototype.getHydrateNode = function (children) {
        if (children === void 0) { children = []; }
        return {
            type: QueryTreeNodeType.HYDRATE,
            collectionSchema: this.collectionSchema,
            children: children,
        };
    };
    QueryPlanner.prototype.getPaginateNode = function (offset, limit, children) {
        if (children === void 0) { children = []; }
        return {
            type: QueryTreeNodeType.PAGINATE,
            offset: offset,
            limit: limit,
            children: children,
        };
    };
    QueryPlanner.prototype.getSortNode = function (path, order, children) {
        if (children === void 0) { children = []; }
        return {
            type: QueryTreeNodeType.SORT,
            path: path,
            order: order,
            comparer: this.comparer,
            children: children,
        };
    };
    QueryPlanner.prototype.getMemFilterNode = function (intervals, path, children) {
        return {
            type: QueryTreeNodeType.FILTER,
            comparer: this.comparer,
            path: path,
            intervals: intervals,
            regroup: false,
            children: [
                // Load the data
                {
                    type: QueryTreeNodeType.HYDRATE,
                    collectionSchema: this.collectionSchema,
                    children: children || [this.getScanAllNode()],
                },
            ],
        };
    };
    QueryPlanner.prototype.getIndexScanNode = function (intervals, index) {
        return {
            type: QueryTreeNodeType.INDEX_SCAN,
            collectionSchema: this.collectionSchema,
            index: index,
            intervals: intervals,
            comparer: this.comparer,
            children: [],
        };
    };
    QueryPlanner.prototype.getScanNode = function (intervals) {
        return {
            type: QueryTreeNodeType.SCAN,
            collectionSchema: this.collectionSchema,
            intervals: intervals,
            comparer: this.comparer,
            children: [],
        };
    };
    QueryPlanner.prototype.getScanAllNode = function () {
        return {
            type: QueryTreeNodeType.SCAN_ALL,
            collectionSchema: this.collectionSchema,
            comparer: this.comparer,
            children: [],
        };
    };
    QueryPlanner.prototype.getSkipNode = function () {
        return { type: QueryTreeNodeType.FILL, inputs: [[]], children: [] };
    };
    return QueryPlanner;
}());
export { QueryPlanner };
export default QueryPlanner;
//# sourceMappingURL=query-planner.js.map